/** Evento window per errori persistenza bozza SQLite (middleware → listener UI). */
export const DRAFT_PERSISTENCE_ERROR_EVENT = 'draft-persistence-error';
